import { request } from './repository';

const url = 'source-service-types/';


const sourceServiceTypeRepository = {
    getSourceServiceTypes() {
        return request.get(url);
    },
    storeSourceServiceType(data) {
        return request.post(url, data);
    },
    updateSourceServiceType(id, data) {
        return request.put(url + id, data);
    },
    deleteSourceServiceType(id) {
        return request.delete(url + id);
    }
}

export default sourceServiceTypeRepository;